import React from 'react';

const companyName = "ANESDEV";
const email = "anesserdev@gmail.com";

export const privacyPolicyContent = (
  <>
    <p className="mb-8 text-gray-400 leading-relaxed">
      At {companyName}, we value your trust and are committed to protecting your privacy. This Privacy Policy describes how we collect, use, store, and safeguard your personal information when you use our website and IT services. By accessing or using our website, you agree to the terms of this Privacy Policy.
    </p>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">1. Information We Collect</h3>
    <p className="mb-4 text-gray-400">We may collect the following types of information:</p>
    <ul className="list-disc pl-6 mb-8 space-y-3 text-gray-400">
      <li><strong className="text-white">Personal Identification Information:</strong> Your name, email address, phone number, billing information, and any details you provide when filling out forms or contacting us.</li>
      <li><strong className="text-white">Business Information:</strong> Company name, project details, and technical requirements shared for IT service delivery.</li>
      <li><strong className="text-white">Technical Data:</strong> IP address, browser type, operating system, device identifiers, and cookies.</li>
      <li><strong className="text-white">Usage Data:</strong> Information about how you use our website, including pages visited, time spent, and interactions.</li>
    </ul>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">2. How We Use Your Information</h3>
    <p className="mb-4 text-gray-400">We use your data to:</p>
    <ul className="list-disc pl-6 mb-8 space-y-2 text-gray-400">
      <li>Provide and deliver our IT solutions and services.</li>
      <li>Personalize your user experience on our website.</li>
      <li>Communicate with you regarding inquiries, support requests, and updates.</li>
      <li>Send promotional offers, newsletters, or marketing materials (you can unsubscribe at any time).</li>
      <li>Improve website functionality, security, and user experience.</li>
      <li>Comply with legal obligations and enforce our policies.</li>
    </ul>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">3. Data Protection and Security</h3>
    <p className="mb-8 text-gray-400 leading-relaxed">
      We implement appropriate administrative, technical, and physical safeguards to protect your personal data against unauthorized access, alteration, disclosure, or destruction. While we take strong security measures, no method of transmission over the Internet is 100% secure.
    </p>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">4. Cookies and Tracking Technologies</h3>
    <p className="mb-8 text-gray-400 leading-relaxed">
      Our website may use cookies, beacons, and tracking tools to enhance your browsing experience. You may disable cookies in your browser, but certain website features may not function properly.
    </p>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">5. Sharing and Disclosure of Information</h3>
    <p className="mb-4 text-gray-400">We do not sell or rent your personal information. However, we may share information with:</p>
    <ul className="list-disc pl-6 mb-8 space-y-3 text-gray-400">
      <li><strong className="text-white">Service Providers & Contractors:</strong> For payment processing, hosting, and technical support.</li>
      <li><strong className="text-white">Legal Authorities:</strong> If required by law, regulation, or legal process.</li>
      <li><strong className="text-white">Business Transfers:</strong> In case of a merger, acquisition, or sale of assets.</li>
    </ul>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">6. Your Rights</h3>
    <p className="mb-4 text-gray-400">Depending on your location, you may have rights to:</p>
    <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-400">
      <li>Access, correct, or delete your personal information.</li>
      <li>Restrict or object to certain types of data processing.</li>
      <li>Request data portability.</li>
      <li>Withdraw consent for marketing communications.</li>
    </ul>
    <p className="mb-8 text-gray-400">
      To exercise your rights, email us at <a href={`mailto:${email}`} className="text-electric-green hover:underline">{email}</a>.
    </p>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">7. Data Retention</h3>
    <p className="mb-8 text-gray-400 leading-relaxed">
      We retain personal information only for as long as necessary to provide services, comply with legal obligations, and resolve disputes.
    </p>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">8. Third-Party Links</h3>
    <p className="mb-8 text-gray-400 leading-relaxed">
      Our website may include links to third-party sites. We are not responsible for their privacy practices, and we encourage you to review their policies.
    </p>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">9. Changes to Privacy Policy</h3>
    <p className="mb-8 text-gray-400 leading-relaxed">
      We may update this Privacy Policy periodically. Updates will be posted on this page with a revised "Effective Date."
    </p>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">10. Contact Us</h3>
    <p className="mb-8 text-gray-400 leading-relaxed">
      If you have any questions about this Privacy Policy, contact us at:<br />
      <strong className="text-white mt-2 inline-block">Email:</strong> <a href={`mailto:${email}`} className="text-electric-green hover:underline">{email}</a>
    </p>
  </>
);

export const refundPolicyContent = (
  <>
    <p className="mb-8 text-gray-400 leading-relaxed">
      At {companyName}, we strive to provide the best IT services possible. However, we understand situations may arise where refunds are necessary. This Refund Policy outlines the terms under which refunds may be issued.
    </p>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">1. Service-Based Refunds</h3>
    <p className="mb-4 text-gray-400">
      Refunds are available only if the service was not delivered as agreed upon or if there is a clear defect in the service provided.
    </p>
    <ul className="list-disc pl-6 mb-8 space-y-2 text-gray-400">
      <li>Requests must be made within 7 days of delivery.</li>
      <li>Work that has already been completed and delivered is non-refundable.</li>
    </ul>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">2. Digital Products and Software</h3>
    <p className="mb-8 text-gray-400 leading-relaxed">
      All digital products, software, or licenses purchased from {companyName} are non-refundable once delivered, unless the product is proven defective or inaccessible.
    </p>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">3. Customized Solutions</h3>
    <p className="mb-8 text-gray-400 leading-relaxed">
      Since IT solutions often involve custom development or consulting, refunds are not guaranteed once significant work has begun. However, we will work with clients to resolve issues in good faith.
    </p>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">4. Payment Disputes</h3>
    <p className="mb-8 text-gray-400 leading-relaxed">
      If a payment is disputed through a bank or payment processor, {companyName} reserves the right to suspend or terminate services until the dispute is resolved.
    </p>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">5. Refund Process</h3>
    <p className="mb-4 text-gray-400">To initiate a refund, please follow these steps:</p>
    <ul className="list-disc pl-6 mb-8 space-y-3 text-gray-400">
      <li>Submit a refund request via email to <a href={`mailto:${email}`} className="text-electric-green hover:underline">{email}</a>.</li>
      <li>Include your order/project details, the reason for the refund, and any supporting documentation.</li>
      <li>Approved refunds will be issued within 7–14 business days to the original payment method.</li>
    </ul>
  </>
);

export const termsOfServiceContent = (
  <>
    <p className="mb-8 text-gray-400 leading-relaxed">
      These Terms of Service (“Terms”) govern your use of the {companyName} website and IT services. By using our services, you agree to comply with these Terms. If you do not agree, please discontinue use of our website and services.
    </p>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">1. Services Provided</h3>
    <p className="mb-8 text-gray-400 leading-relaxed">
      {companyName} provides IT solutions, consulting, and digital services. Details, scope, and pricing are communicated before project initiation.
    </p>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">2. User Responsibilities</h3>
    <ul className="list-disc pl-6 mb-8 space-y-3 text-gray-400">
      <li>You agree to provide accurate and updated information when engaging with our services.</li>
      <li>You are responsible for ensuring that your use of our services complies with all applicable laws.</li>
      <li>You must not use our services for unlawful, harmful, or malicious activities, including spreading malware, hacking, or unauthorized data access.</li>
    </ul>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">3. Payments</h3>
    <ul className="list-disc pl-6 mb-8 space-y-3 text-gray-400">
      <li>All services must be paid for in advance unless otherwise agreed.</li>
      <li>Payments are accepted via approved payment methods listed on our website.</li>
      <li>{companyName} reserves the right to suspend services for late or unpaid invoices.</li>
    </ul>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">4. Refunds</h3>
    <p className="mb-8 text-gray-400 leading-relaxed">
      Refunds are governed by our Refund Policy, which is an integral part of these Terms.
    </p>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">5. Intellectual Property</h3>
    <ul className="list-disc pl-6 mb-8 space-y-3 text-gray-400">
      <li>All content, trademarks, designs, and service materials on {companyName} are the intellectual property of {companyName}.</li>
      <li>Clients retain ownership of their own data, but by using our services, grant {companyName} a limited license to use it solely for project execution.</li>
    </ul>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">6. Limitation of Liability</h3>
    <ul className="list-disc pl-6 mb-8 space-y-3 text-gray-400">
      <li>{companyName} is not responsible for indirect, incidental, or consequential damages arising from the use of our services.</li>
      <li>We do not guarantee uninterrupted service or error-free results, although we aim to deliver the highest quality.</li>
    </ul>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">7. Termination of Services</h3>
    <ul className="list-disc pl-6 mb-8 space-y-3 text-gray-400">
      <li>{companyName} may suspend or terminate services if you violate these Terms.</li>
      <li>You may terminate services at any time, but outstanding fees remain payable.</li>
    </ul>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">8. Modifications</h3>
    <p className="mb-8 text-gray-400 leading-relaxed">
      We may update these Terms periodically. Continued use of our services constitutes acceptance of the updated Terms.
    </p>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">9. Governing Law</h3>
    <p className="mb-8 text-gray-400 leading-relaxed">
      These Terms are governed by the laws of the State of Wyoming, United States, without regard to conflict of law principles.
    </p>

    <h3 className="text-xl font-bold text-white mb-4 mt-8">10. Contact</h3>
    <p className="mb-8 text-gray-400 leading-relaxed">
      For questions about these Terms, contact us at:<br />
      <strong className="text-white mt-2 inline-block">Email:</strong> <a href={`mailto:${email}`} className="text-electric-green hover:underline">{email}</a>
    </p>
  </>
);